import dayjs from "dayjs";

import {
  HotelsSortOptions,
  SortOrder,
  TravelPurpose,
} from "@/app/lib/types/enums";
import type {
  HotelsSortValue,
  THotelFormFieldValues,
} from "@/features/hotels/types/types";

export const initialHotelsValues: THotelFormFieldValues = {
  destination: null,
  dates: {
    checkIn: dayjs().startOf("day").toDate(),
    checkOut: dayjs().startOf("day").add(1, "day").toDate(),
  },
  rooms: [
    {
      adults: 1,
      children: 0,
      childrenAges: [] as number[],
    },
  ],
  travelPurpose: TravelPurpose.LEISURE,
};

export const initialSortValue: HotelsSortValue = {
  field: HotelsSortOptions.RECOMMENDED,
  order: SortOrder.ASC,
};
